import { render, staticRenderFns } from "./partner-links-list.vue?vue&type=template&id=38809822&scoped=true&"
import script from "./partner-links-list.vue?vue&type=script&lang=js&"
export * from "./partner-links-list.vue?vue&type=script&lang=js&"
import style0 from "./partner-links-list.vue?vue&type=style&index=0&id=38809822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38809822",
  null
  
)

export default component.exports